import './HeroLayoutwithHeader.css';
import React, { useEffect, useState} from 'react';
import { CacheProvider } from '@emotion/react';
import Link from '@mui/material/Link';
import Slider from "react-slick";
import IconButton from '@mui/material/IconButton';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
// import { FrontAwesomeIcon } from '@fortawesome/react-frontawesome';
// import { faXmark } from '@fortawesome/free-solid-svg-icons';
//import Grid from '@mui/material/Grid';
import { appendStyleSheet, getEndpoint, getID, getMUICache, getUrl, getImageSize, getImageUrl, isImageSizeBlank, GetFallBackImage, getImageId, getLoggedInFlag, safeCharAt, fetchAnchorValue, GetIconsSprites } from '../../../common/utils';
import { I_CDSListingItemTO } from '@interfaces/ICDSListingResponseTO';
import bcrypt from 'bcryptjs-react';
import MainMenuThree from '../MainMenuThree/MainMenuThree';
import { PAGEBUILDER_URLS } from '../../Common/Constant'; 
import { getLoggedUserName, getLoggedUserEmail,logoutUser  } from "../../../common/utils"; 
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages,PreloadViewportImages, ImageLoader} from '../../../components/IntersectionObserver/imageComponent';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

HeroLayoutwithHeader.version = 1000;
HeroLayoutwithHeader.lang = 'en';
HeroLayoutwithHeader.langs = ['en'];
HeroLayoutwithHeader.setLang = (lang: any) => {
  HeroLayoutwithHeader.lang = lang;
}

Object.defineProperty(HeroLayoutwithHeader, 'name', {
  writable: true,
  value: 'HeroLayoutwithHeader'
});

export function HeroLayoutwithHeader(props: any) {

  const { anchorLinksValue } = props;

  let styles = require("./HeroLayoutwithHeader.css");
  const [msid, setMsid] = useState<any>('');
  const [items, setItems] = useState<I_CDSListingItemTO[]>([]);
  const [items_header, setItems_Header] = useState<any[]>([]);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [headerData, setHeaderData] = useState<any>({});
  const [active, setActive] = useState(false);
  const carouselRef = React.useRef(null);
  appendStyleSheet("HeroLayoutwithHeader", styles);
  const { CONSTANTS, noOfHeaderItems } = props;
  const endpoint = getEndpoint(props, "MAIN");
  const headerMenuEndpoint = getEndpoint(props, "HEADER_MENU_API");
  const siteResourceEndpoint = getEndpoint(props, "HEADER_WRAPPER");
  const [loggedUserName, setLoggedUserName] = useState("");
  const [loggedUserEmail, setLoggedUserEmail] = useState("");
  const [loginLink, setLoginLink] = useState("");
  const [loginEnabled, setLoginEnabled] = useState(false);
  //const preloadSet = useRef(new Set<string>()); // Track preloaded image URLs

  const endpointHostId = getEndpoint(props, "HEADER_MENU_API");
  const hostId = endpointHostId.queryParams.hostId;


    
//Preload images when items are available
// useEffect(() => {
//   if (items.length > 0) {
//     items.forEach(item => {
//       const imageUrl = getImageUrl(getImageId(item.imageid), getImageSize(item.imageid), 1440, 768, "", false, props.CONSTANTS);
//       if (!preloadSet.current.has(imageUrl)) {
//         const link = document.createElement('link');
//         link.rel = 'preload';
//         link.href = imageUrl;
//         link.as = 'image';
//         document.head.appendChild(link);
//         preloadSet.current.add(imageUrl); 
//       }
//     });
//   }
// }, [items, props.CONSTANTS]);

//Preload images when items are available


  AddImageDimensions();
  // OptimizeLCP();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();
  
  useEffect(()=>{
    EagerLoadImages()
},[]);
  
        // Add and Remove Class on scroll
          const handleClick = () => {
            setActive(!active); // Toggle the state
          };const className = active ? "active" : "";
        // Add and Remove Class on scroll
  

  if( !loginEnabled && props && props.transportData && props.transportData.isLoginEnabled ) {
    setLoginEnabled(props.transportData.isLoginEnabled);
  }

  const toggleMainMenu = () => {
    setDrawerOpen(!isDrawerOpen);
  };
  useEffect(() => {
    if (!headerMenuEndpoint.isSSR || !headerMenuEndpoint.SSRDataObj) {
      fetchComponentData_Header();
    }

    if( !loginEnabled && props && props.transportData && props.transportData.isLoginEnabled ) {
      setLoginEnabled(props.transportData.isLoginEnabled);
    }
    setLoginEnabled(getLoggedInFlag());
  }, [headerMenuEndpoint]);

  useEffect(() => {
    if (!siteResourceEndpoint.isSSR || !siteResourceEndpoint.SSRDataObj) {
      fetchComponentData_siteRes();
    }
  }, [siteResourceEndpoint,props.showSearch]);

  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj) {
      fetchComponentData();
    }
  }, [props.MSID, endpoint]);

    if (endpoint.isSSR && endpoint.SSRDataObj && (!items || !items.length)
      && endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length !== 0) {
      setItems(endpoint.SSRDataObj.items);
    }
    if (headerMenuEndpoint.isSSR && headerMenuEndpoint.SSRDataObj && headerMenuEndpoint.SSRDataObj.length && Object.keys(items_header).length === 0) {
      if (Array.isArray(headerMenuEndpoint.SSRDataObj)) {
        setItems_Header(headerMenuEndpoint.SSRDataObj);
      } else {
        console.error('Unexpected response structure', headerMenuEndpoint.SSRDataObj);
      }
    }

    if (siteResourceEndpoint !== undefined && siteResourceEndpoint && siteResourceEndpoint.isSSR && siteResourceEndpoint.SSRDataObj
      && headerData && Object.keys(headerData).length === 0) {
        setHeaderData(siteResourceEndpoint.SSRDataObj);
    }


  const fetchComponentData = () => {
    getData(getUrl(props));
  }

  const fetchComponentData_Header = () => {
    let menuAPIurl = getUrl(props, 0, false, "HEADER_MENU_API", true);
    getData_Header(menuAPIurl);
  }

  const fetchComponentData_siteRes = () => {
    const { ENDPOINTS } = props;
    let headerAPI = getUrl(props, 0, false, "HEADER_WRAPPER", true, ENDPOINTS[0].queryParams.websiteId, ENDPOINTS[0].queryParams.clientId)
    getData_Header_siteRes(headerAPI);
  }

 
  
  const getData = (url: string) => {
    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = { 'p-nonce': headerString };
    fetch(url, { headers: headers })
      .then((response) => response.json())
      .then(response => {
        setItems(response.items);
      })
      .catch(err => {
        //console.log(err);
      });
  }

  const getData_Header = (url: string) => {
    let headerString2 = '?' + url.split("?")[1];
    headerString2 = bcrypt.hashSync(headerString2, 6);
    const headers2 = { 'p-nonce': headerString2 };

    fetch(url, { headers: headers2 })
      .then((response) => response.json())
      .then(response => {
        if (Array.isArray(response)) {
          setItems_Header(response);
        } else {
          console.error('Unexpected response structure', response);
        }
      })
      .catch(err => {
        //console.log(err);
      });
  }

  const getData_Header_siteRes = (url: string) => {
    fetch(url)
      .then((response) => response.json())
      .then(response => {
        if (typeof response === 'object' && response !== null) {
          setHeaderData(response);
        } else {
          console.error('Unexpected response structure', response);
        }
      })
      .catch(err => {
        //console.log(err);
      });
  }


  // if (endpoint.isSSR && endpoint.SSRDataObj && (!headerData || !Object.keys(headerData).length)) {
  //   setHeaderData(endpoint.SSRDataObj);

  //   if (isSticky) {
  //     setTimeout(() => {
  //       if (typeof document !== 'undefined' && undefined !== document && document && document.getElementsByTagName("header") && document.getElementsByTagName("header")[0])
  //         document.getElementsByTagName("header")[0].classList.add("sticky");
  //     })
  //   }
  // }
  useEffect(() => {
    setLoggedUserName(getLoggedUserName());
    setLoggedUserEmail(getLoggedUserEmail());
    setLoginLink("/login?url=" + encodeURIComponent(window.location.href));
  }, []);

  // Determine if the email exists
  const hasUserEmail = !!loggedUserEmail;
  
  const getLoginString = () => {
    if( loginEnabled ) {
      if (loggedUserName) {
        return (
          <>
            <div className="ThemeThreeWelcomeWrapperMobile">
              <button className="ThemeThreeAfterLoginButtonMobile">
                {safeCharAt(loggedUserName)}
              </button>
    
              <div className="ThemeTwoWelcomeUserDetails">
                <li className="UserNameAfterLogIn">{loggedUserName}</li>
                <li className="UserEmailAfterLogIn">{loggedUserEmail}</li>
              </div>
            </div>
            {/* <div className="ThemeThreeListLogMobile">
              <li>
                {" "}
                <a onClick={logoutUser} href="javascript:void(0)">
                  Logout
                </a>
              </li>
            </div> */}
          </>
        );
      }
      return (
        <div className="ThemeThreeLoginWrapperMobile">
          <a href={loginLink} className="ThemeThreeLoginAnchorMobile">
          <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z"
            fill="#F29D38"
          />
          <mask id="path-2-inside-1_13_3229" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M20.33 18.45C21.6914 18.45 22.9971 18.9908 23.9598 19.9535C24.9225 20.9162 25.4633 22.2219 25.4633 23.5833V25.75L25.4571 25.8503C25.4077 26.2448 25.0712 26.55 24.6633 26.55C24.2215 26.55 23.8633 26.1918 23.8633 25.75V23.5833C23.8633 22.6462 23.4911 21.7475 22.8284 21.0849L22.6714 20.9372C22.0273 20.3672 21.195 20.05 20.33 20.05H11.6634L11.4479 20.0566C10.5894 20.109 9.77658 20.4732 9.16492 21.0849C8.50229 21.7475 8.13003 22.6462 8.13003 23.5833V25.75L8.1238 25.8503C8.07443 26.2448 7.73787 26.55 7.33003 26.55C6.8882 26.55 6.53003 26.1918 6.53003 25.75V23.5833L6.53634 23.3288C6.59928 22.06 7.13103 20.856 8.03355 19.9535C8.99623 18.9908 10.3019 18.45 11.6634 18.45H20.33Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.33 18.45C21.6914 18.45 22.9971 18.9908 23.9598 19.9535C24.9225 20.9162 25.4633 22.2219 25.4633 23.5833V25.75L25.4571 25.8503C25.4077 26.2448 25.0712 26.55 24.6633 26.55C24.2215 26.55 23.8633 26.1918 23.8633 25.75V23.5833C23.8633 22.6462 23.4911 21.7475 22.8284 21.0849L22.6714 20.9372C22.0273 20.3672 21.195 20.05 20.33 20.05H11.6634L11.4479 20.0566C10.5894 20.109 9.77658 20.4732 9.16492 21.0849C8.50229 21.7475 8.13003 22.6462 8.13003 23.5833V25.75L8.1238 25.8503C8.07443 26.2448 7.73787 26.55 7.33003 26.55C6.8882 26.55 6.53003 26.1918 6.53003 25.75V23.5833L6.53634 23.3288C6.59928 22.06 7.13103 20.856 8.03355 19.9535C8.99623 18.9908 10.3019 18.45 11.6634 18.45H20.33Z"
            fill="black"
          />

          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.7865 15.7122C13.052 15.5985 10.8701 13.3457 10.8701 10.5833L10.8746 10.3663C10.9883 7.63192 13.2411 5.45 16.0034 5.45L16.2204 5.4545C18.9549 5.56821 21.1368 7.82096 21.1368 10.5833L21.1323 10.8003C21.0186 13.5347 18.7658 15.7167 16.0034 15.7167L15.7865 15.7122ZM16.1973 14.1114C18.0586 14.0108 19.5368 12.4697 19.5368 10.5833L19.5316 10.3895C19.4309 8.52822 17.8898 7.05 16.0034 7.05L15.8096 7.05523C13.9483 7.15587 12.4701 8.69697 12.4701 10.5833L12.4753 10.7772C12.576 12.6384 14.1171 14.1167 16.0034 14.1167L16.1973 14.1114Z"
            fill="black"
          />
        </svg>{" "}
            <span>login</span>
          </a>
        </div>
      );
    }
  };

  
  const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose }) => {
    return (
<div className='withLogoutButton'>
<div className={`drawer ${isOpen ? 'open' : 'closed'}`}>
        <div className='drawerHeaderMobile'>
        <button aria-label="Close" className="close-btn" onClick={onClose}>
           <div className='bg-Close_icon_black' style={{ backgroundImage: `url(${GetIconsSprites()})` }}></div>
          </button>
        <div className='drawerHeaderMobileLogo'>
                <Link href="/" aria-label="logo" target={fetchAnchorValue(anchorLinksValue, "/")} className="MainLogoThree">
                  {props?.headerData?.mainLogo && <img src={getImageUrl(props?.headerData?.mainLogo, '999', 96, 36, "", false, props?.CONSTANTS)} alt="logo" width="96" height="36"/>}
                </Link>
              </div>
        </div>
        <div className="ThemeThreeMainLoginFunctionWrapMobile">
          {getLoginString()}
         </div>
        <div className="drawer-content">
          {items_header && items_header.map((val, index) => (
            <div key={index} className={`MainDrawerMenuWrapper ${className}`} onClick={handleClick}>
              <div><Link className='MainDrawerMenu' href={val.path} key={'L1_' + index} target={fetchAnchorValue(anchorLinksValue, val.path)} >{val.name}</Link></div>
              {val.sections && val.sections.length > 0 && (
                <div className='MainDrawerMenuSubWrapper'>
                  {val.sections.map((subItem: any, subIndex: any) => (
                    <div key={subIndex}><Link className='MainDrawerSubMenu' href={subItem.path} key={'L2_' + subIndex} target={fetchAnchorValue(anchorLinksValue, subItem.path)}>{subItem.name}</Link></div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <div className="ThemeThreeListLogMobile">
      <li>
        {" "}
      <a onClick={logoutUser} href="javascript:void(0)" className={`logoutLink ${hasUserEmail ? "emailExists" : ""}`}>Logout</a>
        </li>
</div>
</div>
    );
  };

  const NextArrow = (props: any) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <IconButton className='HeroCarousalCustomPrevArrow'>
          <ArrowForwardIosOutlinedIcon />
        </IconButton>

      </div>
    );
  }

  const PrevArrow = (props: any) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        {/* <KeyboardArrowLeftIcon fontSize='medium' /> */}
        <IconButton className='HeroCarousalCustomNextArrow'>
          <ArrowBackIosNewOutlinedIcon />
        </IconButton>
      </div>
    );
  }

  const Carouselsettings = {
    infinite: false, // items.length > 1 ? true : false,
    speed: 500,
    // autoplay: i_scrollMode,
    autoplay: false,
    slidesToShow: 1,
    // slidesToScroll: parseInt(props.scrollCount, 10),
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    swipeToSlide: true,
    variableWidth: false, // Ensure this is false to keep consistent slide width
    dots: false,
    arrows: true,
    adaptiveHeight: false,
    className: 'ThemeThreeHeroLayoutWithNav',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        }
      }
    ]
  };

  const getRenderPart = () => {
    if (msid && props.msid && msid !== props.msid) {
      props.queryParams.msid = props.msid;
      setMsid(props.queryParams.msid);
      getData(getUrl(props));
    }

    if (!items || !items.length) {
      return null;
    }

    let componentID = getID(props.data);
    
    
    return (
      <CacheProvider value={getMUICache()}>
        <div id={componentID}>
          <div>
            <Slider {...Carouselsettings} ref={carouselRef}>
              {items && items.map((itemObj: any, index: any) => { 
                return <div key={'Qitem_' + index} className='ThemeTheeWebQuickViewCardWrapSlide'>
                  <div className='ThemeTwoWebTrnCardWrap'>
                    <div className=' ThemeThreeHeroLayoutNavCardWrap'>
                      <div className='ThemeThreeHeroLayoutNavCardImgWrap'>
                        
                        {isImageSizeBlank(itemObj.imageid) ? <picture>
                          <source media="(min-width: 768px)"  srcSet={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 1440, 796, "", false, props.CONSTANTS,'8')} />
                          <source media="(max-width: 767px)"  srcSet={getImageUrl(getImageId(itemObj.imageid), getImageSize(itemObj.imageid), 430, 459, "", false, props.CONSTANTS,'8')} />
                          <img alt={itemObj?.hl?.slice(0, 25)} title={itemObj?.hl?.slice(0, 25)} loading="lazy"/>
                        </picture> : <img src={GetFallBackImage()} alt={itemObj?.hl?.slice(0, 25)} title={itemObj?.hl?.slice(0, 25)} loading="lazy"/>}
                      </div>

                      <div className='ThexWrapperOnHeroLayout'>
                        <div className='ThemeThreeHerolayoutHeroWrapper'>
                          <p className='HomeHeroLayoutMainHeading'>{itemObj?.hl}</p>
                          <p className='HomeHeroLayoutShortDescription'>{itemObj?.syn}</p>
                        </div>
                        <div className='DiscoverMoreButton'>
                          <Link style={{backgroundColor:props.CTABgColor, color:props.CTATextColor}} href={itemObj.wu} target={fetchAnchorValue(anchorLinksValue, itemObj.wu)} >{props.CTAText}</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              }
              )}
            </Slider>
          </div>
        </div>
      </CacheProvider>
    );
  }

  let defaultDomainUrl: any = "";
  if (typeof window !== 'undefined' && undefined !== window && window) {
    defaultDomainUrl = "https://" + window.location.hostname;
  } else {
    defaultDomainUrl = (props && props.REQUEST_HOSTNAME) && "https://" + props.REQUEST_HOSTNAME;
  }

  
  
  return (
    <>
      {!(typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)))  && <div>
        <Drawer isOpen={isDrawerOpen} onClose={() => setDrawerOpen(false)} />
        <div className={`overlay ${isDrawerOpen ? 'active' : ''}`} onClick={() => setDrawerOpen(false)}></div>
      </div>}

      

      {items_header && items_header.length > 0 && (
        <MainMenuThree
          props={props}
          domainUrl={defaultDomainUrl}
          menuItems={items_header}
          headerMenuEndpoint={headerMenuEndpoint}
          cdsDomain={CONSTANTS.CDS_API}
          toggleMainMenu={toggleMainMenu}
          showSearch={props.showSearch}
          headerData={headerData}
          CONSTANTS={CONSTANTS}
          pagetype="HOME"
          mainLogo={headerData && headerData?.mainLogo}
          noOfHeaderItems={noOfHeaderItems}
          hostId={hostId}
          anchorLinksValue={anchorLinksValue}
        />
      )}
      {getRenderPart()}
    </>
  );
}
